/* unplugin-vue-components disabled */import { render } from "./SimpleQuizPlayer.vue?vue&type=template&id=248e5619&scoped=true&ts=true"
import script from "./SimpleQuizPlayer.vue?vue&type=script&lang=ts"
export * from "./SimpleQuizPlayer.vue?vue&type=script&lang=ts"

import "./SimpleQuizPlayer.vue?vue&type=style&index=0&id=248e5619&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248e5619"]])

export default __exports__